import React from "react";
import classnames from "classnames";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import { FmBox } from "../FmBox";
import { useTheme } from "../../Hooks";
import useStyles from "./FmMessage.style";

type variants = "success" | "failure";

interface FmMessageProps {
    children: React.ReactNode;
    variant?: variants;
    className?: string;
    snackbar?: boolean;
    closeMessage?: any;
}

const FmMessage = ({ children, className, variant = "success", snackbar, closeMessage }: FmMessageProps) => {
    const classes = useStyles();
    const theme = useTheme();
    const isSuccessVariant = variant === "success";

    const rightClass = classnames(classes.right, {
        [classes.success]: isSuccessVariant,
        [classes.failure]: !isSuccessVariant,
    });

    snackbar &&
        setTimeout(() => {
            closeMessage && closeMessage();
        }, 1000);

    return (
        <FmBox className={classnames(classes.container, className)} variant={isSuccessVariant ? "green" : "red"}>
            <div className={classes.left}>
                {!isSuccessVariant && <ErrorOutlineIcon style={{ color: theme.palette.error.main }} />}
                {isSuccessVariant && <img src={theme.images.greenCheckMark} />}
            </div>
            <div className={rightClass}>{children}</div>
        </FmBox>
    );
};

export default FmMessage;
